module.exports = __webpack_public_path__ + "static/media/termsActiveIcon.f46e0cb5.svg";